// extracted by mini-css-extract-plugin
module.exports = {"container":"Dashboard_container__2hG0w","cardsGrid":"Dashboard_cardsGrid__3qNI-"};